<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
          TIPOS EVENTOS
        </ion-title>
        <ion-select class="select-emp pr-2" slot="end" placeholder="EMPRESA" v-model="empresaActual" cancel-text="CANCELAR" @ionChange="listarTiposEventoEmpresa();">
          <ion-select-option v-for="empresa in empresas" :key="empresa.emp_id+'emp'" :value="empresa.emp_id">{{empresa.emp_nombre}}</ion-select-option>
        </ion-select>
      </ion-toolbar>
    </ion-header>
    
    <ion-content>
      <ion-refresher slot="fixed" @ionRefresh="recargarTiposEvento($event);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button color="secondary" @click="muestraModalNuevoTipoEvento();">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
      </ion-fab>

      <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
        <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
          <ion-col size="12">
            <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
          </ion-col>
          <ion-col size="12">
            <ion-label color="dark">CARGANDO...</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-list v-if="tiposEvento.length != 0 && !cargando" lines="full">
        <ion-item v-for="tipo in tiposEvento" :key="tipo.tev_id">
          <div class="container-fluid p-0">
            <div class="row">
              <div class="col-lg-10 col-md-9 col-sm-8 col-8 py-3" style="cursor:pointer;"
                @click="()=>{
                if(verSubTipo1==tipo.tev_id){verSubTipo1=verSubTipo2=''} 
                else {verSubTipo1=tipo.tev_id;}
                }">
                <ion-label >
                  <h3> 
                    <fa v-if="verSubTipo1==tipo.tev_id" :icon="['fal', 'chevron-down']" class="fa-fw"></fa>
                    <fa v-else :icon="['fal', 'chevron-right']" class="fa-fw"></fa>
                    <fa v-if="tipo.tev_prioridad == 1" :icon="['fad', 'parking-circle']" class="fa-fw text-danger"></fa>
                    <fa v-if="tipo.tev_prioridad == 2" :icon="['fad', 'parking-circle']" class="fa-fw text-warning"></fa>
                    <fa v-if="tipo.tev_prioridad == 3" :icon="['fad', 'parking-circle']" class="fa-fw text-success"></fa>
                    {{tipo.tev_tipo.toUpperCase()}}
                  </h3>
                </ion-label>
              </div>
              <div class="col-lg-2 col-md-3 col-sm-4 col-4 pt-3">
                <ion-label>
                  <h3 class="text-right">
                    <span @click="muestraModalNuevoTipoEvento(tipo)"><fa :icon="['fad', 'plus-circle']" class="fa-fw" style="font-size:20px; cursor:pointer;"></fa></span>
                    <span @click="muestraModalVerTipoEvento(tipo)"><fa :icon="['fad', 'edit']" class="fa-fw ml-2" style="font-size:20px; cursor:pointer;"></fa></span>
                  </h3>
                </ion-label>
              </div>
            </div>
            <div class="row">
              <div v-if="verSubTipo1==tipo.tev_id" class="col-12">
                <ion-list v-if="tipo.sub_tipos.length > 0" class="border py-0 mb-2">
                  <ion-item v-for="tipo2 in tipo.sub_tipos" :key="tipo2.tev_id+'2'">
                    <div class="container-fluid p-0">
                      <div class="row">
                        <div class="col-lg-10 col-md-9 col-sm-8 col-8 py-3" style="cursor:pointer;"
                          @click="()=>{
                          if(verSubTipo2==tipo2.tev_id){verSubTipo2=''} 
                          else {verSubTipo2=tipo2.tev_id;}
                          }">
                          <ion-label>
                            <h3> 
                              <fa v-if="verSubTipo2==tipo2.tev_id" :icon="['fal', 'chevron-down']" class="fa-fw"></fa>
                              <fa v-else :icon="['fal', 'chevron-right']" class="fa-fw"></fa>
                              <fa v-if="tipo2.tev_prioridad == 1" :icon="['fad', 'parking-circle']" class="fa-fw text-danger"></fa>
                              <fa v-if="tipo2.tev_prioridad == 2" :icon="['fad', 'parking-circle']" class="fa-fw text-warning"></fa>
                              <fa v-if="tipo2.tev_prioridad == 3" :icon="['fad', 'parking-circle']" class="fa-fw text-success"></fa>
                              {{tipo2.tev_tipo.toUpperCase()}}
                            </h3>
                          </ion-label>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-4 col-4 pt-3">
                          <ion-label>
                            <h3 class="text-right">
                              <span @click="muestraModalNuevoTipoEvento(tipo2)"><fa :icon="['fad', 'plus-circle']" class="fa-fw" style="font-size:20px; cursor:pointer;"></fa></span>
                              <span @click="muestraModalVerTipoEvento(tipo2)"><fa :icon="['fad', 'edit']" class="fa-fw ml-2" style="font-size:20px; cursor:pointer;"></fa></span>
                            </h3>
                          </ion-label>
                        </div>
                      </div>
                      <div class="row">
                        <div v-if="verSubTipo2==tipo2.tev_id" class="col-12">
                          <ion-list v-if="tipo2.sub_tipos.length > 0" class="border py-0 mb-2">
                            <ion-item v-for="tipo3 in tipo2.sub_tipos" :key="tipo3.tev_id+'3'">
                              <div class="container-fluid p-0">
                                <div class="row">
                                  <div class="col-lg-10 col-md-9 col-sm-9 col-9 py-3">
                                    <ion-label>
                                      <h3> 
                                        <fa v-if="tipo3.tev_prioridad == 1" :icon="['fad', 'parking-circle']" class="fa-fw text-danger"></fa>
                                        <fa v-if="tipo3.tev_prioridad == 2" :icon="['fad', 'parking-circle']" class="fa-fw text-warning"></fa>
                                        <fa v-if="tipo3.tev_prioridad == 3" :icon="['fad', 'parking-circle']" class="fa-fw text-success"></fa>
                                        {{tipo3.tev_tipo.toUpperCase()}}
                                      </h3>
                                    </ion-label>
                                  </div>
                                  <div class="col-lg-2 col-md-3 col-sm-3 col-3 pt-3">
                                    <ion-label>
                                      <h3 class="text-right">
                                        <span @click="muestraModalVerTipoEvento(tipo3)"><fa :icon="['fad', 'edit']" class="fa-fw" style="font-size:20px; cursor:pointer;"></fa></span>
                                      </h3>
                                    </ion-label>
                                  </div>
                                </div>
                              </div>
                            </ion-item>
                          </ion-list>
                          <ion-label v-else>
                            <h3 class="ml-4 my-3 font-italic text-secondary">NO HAY SUB-TIPOS REGISTRADOS</h3>
                          </ion-label>
                        </div>
                      </div>
                    </div>
                  </ion-item>
                </ion-list>
                <ion-label v-else>
                  <h3 class="ml-4 my-3 font-italic text-secondary">NO HAY SUB-TIPOS REGISTRADOS</h3>
                </ion-label>
              </div>
            </div>
          </div>

        </ion-item>
      </ion-list>

      <div v-if="tiposEvento.length == 0" class="row mt-3">
        <div class="col text-center">
          SIN TIPOS DE EVENTOS REGISTRADOS.
        </div>
      </div>
    </ion-content>
    
  </ion-page>
</template>

<script>
import { Preferences  } from '@capacitor/preferences';
import { addIcons } from 'ionicons';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonMenuButton, IonButtons, IonIcon, IonLabel, IonRefresher, IonRefresherContent, 
        IonFab, IonFabButton, IonSpinner, IonGrid, IonRow, IonCol, IonList, IonItem, modalController, toastController, loadingController, 
        IonSelect, IonSelectOption } from '@ionic/vue';
import { add } from 'ionicons/icons';
import { defineComponent } from 'vue';

import { cerrarSesion }   from '@/plugins/funciones.ts';
import axios              from 'axios';
import rutaBase           from '@/plugins/variables';
import mNuevoTipoEvento   from '../../components/ModalNuevoTipoEvento.vue';
import mVerTipoEvento     from '../../components/ModalVerTipoEvento.vue';

export default defineComponent({
  name: 'TiposEventos',
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonMenuButton, IonButtons, IonIcon, IonLabel, IonRefresher, IonRefresherContent, IonFab, 
    IonFabButton, IonSpinner, IonGrid, IonRow, IonCol, IonList, IonItem, IonSelect, IonSelectOption
  },
  data() {
    return { 
      cargando              : false,
      tiposEvento           : [],
      modalNuevoTipoEvento  : null,
      modalVerTipoEvento    : null,
      verSubTipo1           : '',
      verSubTipo2           : '',
      modalCargando         : null,
      empresas              : [],
      empresaActual         : ''
    }
  },
  created() {
    addIcons({
      'add' : add
    });
  },
  mounted(){
    this.listarEmpresas();
  },
  methods:{
    async muestraModalCargando(){
      const modalCargando = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : false,
          mode      : 'md'
        });
      await modalCargando.present();
      return modalCargando;
    },

    async listarEmpresas(){
      const modalCargando   = await this.muestraModalCargando();
      const token           = await Preferences.get({ key: 'token_auth' });
      const headers         = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarEmpresasPorRut', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.empresas = resp.data.empresas;
        this.empresaActual = this.empresas[0].emp_id;
        modalCargando.dismiss();
        this.listarTiposEventoEmpresa();
      }).catch(()=>{
        modalCargando.dismiss();
        this.muestraToast('ERROR AL OBTENER EMPRESAS.');
      });
    }, 

    async recargarTiposEvento(evento=false){
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      const dato    = new URLSearchParams();
      dato.append('id_empresa', this.empresaActual);
      axios.post(rutaBase+'/administrador/listarTiposEventoEmpresa', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.tiposEvento = resp.data.tiposEvento;
        if(evento){ evento.target.complete(); }
      }).catch(() =>{
        if(evento){ evento.target.complete(); }
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async listarTiposEventoEmpresa(){
      const modalCargando = await this.muestraModalCargando();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      dato.append('id_empresa', this.empresaActual);
      axios.post(rutaBase+'/administrador/listarTiposEventoEmpresa', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.tiposEvento  = resp.data.tiposEvento;
        modalCargando.dismiss();
      }).catch(() =>{
        modalCargando.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraModalNuevoTipoEvento(padre=null){
      this.modalNuevoTipoEvento = await modalController
        .create({
          component       : mNuevoTipoEvento,
          componentProps  : {padre: padre},
          backdropDismiss : false
        });
      this.modalNuevoTipoEvento.present();
      const modalResponse = await this.modalNuevoTipoEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    async muestraModalVerTipoEvento(tipoEvento){
      this.modalVerTipoEvento = await modalController
        .create({
          component       : mVerTipoEvento,
          componentProps  : {propTipoEvento: tipoEvento},
          backdropDismiss : false
        });
      this.modalVerTipoEvento.present();
      const modalResponse = await this.modalVerTipoEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    async modalCloseHandler(_value) {
      const datos = _value;
      if(datos.recargar){
        this.listarTiposEventoEmpresa();
      }
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
    
  }
});
</script>
